import React, {Component} from 'react';
import {observer} from 'mobx-react';
import {action, observable, runInAction} from 'mobx';
import PropTypes from 'prop-types';
import CircularLoader from "../CircularLoader";
import FileAttach from "./index";
import {FormattedMessage} from 'react-intl';
import {disabledDark, primary} from "../../themes/colors";
import MdAttachFile from 'react-icons/lib/md/attach-file';
import Close from 'react-icons/lib/io/close';
import './style.scss';
import SvgIconButton from "../SvgIconButton";
import infoIcon from '../../assets/images/info';

const infoIconStyle = {
    width: '10px',
    height: '10px',
    minWidth: '10px',
    minHeight: '10px',
    borderRadius: 0
};

const defaultFileExtension = 'image/*,.doc,.docx,.musicxml,.xml,.mxl,.pdf,application/pdf';

@observer
class FileAttachList extends Component {
    @observable error = false;

    @action onError=() => {
        this.error = true;
        setTimeout(() => {
            runInAction(() => {
                this.error = false;
            })
        }, 3000);
    };

    render() {
        const {files, onFileChange, onFileDelete, openFilePreview, isFileLoading, disabled, placeholderText, fileExtension} = this.props;
        return <div className={`file-attach-wrapper ${disabled ? 'disabled' : ''} `} >
            <div className="publish-attach-files">
                {files.map((file, id) => {
                    return (
                        <div key={`${file.name}${id}`} className="publish-attach-file">
                            <MdAttachFile style={{fontSize: 18, position: 'absolute', left: 7, top: 6, fill: primary, transform: 'rotate(45deg)'}} />
                            <a className="link" title={file.name} onClick={openFilePreview(file)}>{file.name}</a>
                            <button className="publish-attach-close" style={{position: 'absolute', right: 6, top: 8}}
                                    onClick={() => onFileDelete(file.name)}>
                                <Close style={{fontSize: 15, fill: disabledDark}}/>
                            </button>
                        </div>);
                })}
                {isFileLoading && <CircularLoader/>}
            </div>
            <FileAttach style={{width: '100%'}} className="button" onChange={onFileChange} fileExtension={fileExtension || defaultFileExtension} onError={this.onError} disabled={disabled}>
                <button disabled={disabled} className="publish-attach-button" type="button">
                    <FormattedMessage id={placeholderText || 'createLesson.attachmentPlaceholder'}/>
                </button>
            </FileAttach>
            {this.error &&
            <div className="file-input-error">
                <SvgIconButton
                    viewBox="0 0 12 12" icon={infoIcon} buttonStyle={infoIconStyle} hoverColor="none" rippleColor="none"
                    iconStyle={infoIconStyle} containerClass="file-input-error-icon"/>
                <FormattedMessage id="upload.form.notations.error.fileNotSup"/>
            </div>
            }
        </div>;
   }
}

FileAttachList.propTypes = {
    files: PropTypes.array.isRequired,
    fileExtension: PropTypes.string,
    onFileChange: PropTypes.func,
    onFileDelete: PropTypes.func,
    openFilePreview: PropTypes.func,
    isFileLoading: PropTypes.bool,
    placeholderText: PropTypes.string
};

export default FileAttachList;
